{
  "dashboard": {
    "title": "Сервисы",
    "subtitle": "Выберите сервис для продолжения",
    "loading": "Загрузка сервисов...",
    "noServices": "Для этого тенанта нет активных сервисов.",
    "queryServiceUnavailable": "Запрошенный сервис недоступен для этого тенанта."
  },
  "services": {
    "events": {
      "title": "События",
      "description": "Афиша мероприятий и инструкции по навигации к площадкам."
    },
    "digitalMedia": {
      "title": "Магазин цифрового контента",
      "description": "Курсы, аудио-издания и подписочный обучающий контент."
    }
  },
  "staff": {
    "title": "Инструменты персонала",
    "badge": "Управление",
    "events": {
      "manager": {
        "title": "Менеджер событий",
        "description": "Управляйте своими событиями и локациями"
      }
    },
    "digitalMedia": {
      "manager": {
        "title": "Менеджер цифрового контента",
        "description": "Управление курсами и уроками"
      }
    }
  },
  "errors": {
    "loadServices": "Не удалось загрузить список сервисов. Попробуйте снова."
  },
  "service": {
    "unavailable": "Сервис не включен для текущего тенанта."
  },
  "main": {
    "badge": "Ежедневная энергия",
    "title": "Путь к себе",
    "heroPill": "Новое видео",
    "heroTitle": "Медитация Изобилия\nначинается сегодня",
    "heroAlt": "Рассвет над горной вершиной",
    "materials": "Материалы",
    "retreats": "Ретриты",
    "chat": "Чат",
    "navigator": "Навигатор",
    "retreatsAlt": "Фон карточки ретритов",
    "navigatorAlt": "Фон карточки навигатора",
    "affirmationBadge": "Аффирмация дня",
    "affirmation": "\"Мой потенциал безграничен, как само пространство.\""
  },
  "navigator": {
    "title": "Катя Колобаева",
    "subtitle": "Проводник к вашей внутренней силе. Исследуйте материалы, ретриты и присоединяйтесь к сообществу.",
    "profileAlt": "Портрет духовного проводника",
    "consultation": "Записаться на консультацию",
    "links": {
      "website": "Сайт",
      "instagram": "Instagram",
      "youtube": "YouTube",
      "boosty": "Boosty",
      "telegramChannel": "Telegram Канал",
      "tiktok": "TikTok"
    }
  },
  "search": {
    "placeholder": "Поиск по экосистеме..."
  },
  "trending": {
    "title": "Актуальное",
    "swipe": "Листайте →",
    "item1": {
      "badge": "События",
      "title": "Обновлен календарь событий на неделю"
    },
    "item2": {
      "badge": "Цифровой контент",
      "title": "Новый премиум-курс уже доступен"
    }
  },
  "categories": {
    "title": "Категории",
    "eventsBot": "События",
    "digitalMedia": "Цифровой контент"
  },
  "partnership": {
    "title": "Стань партнером",
    "subtitle": "Разместите свой бизнес в нашей экосистеме сегодня",
    "action": "Подробнее"
  },
  "footer": {
    "home": "Главная",
    "materials": "Материалы",
    "events": "События",
    "retreats": "Ретриты",
    "navigator": "Навигатор",
    "search": "Поиск",
    "favorites": "Избранное",
    "profile": "Профиль"
  }
}
